module.exports = ".red-border-class{\n  border: 1px solid red !important;\n}"